import { render } from "./CustomDone.vue?vue&type=template&id=c165a2a2&scoped=true"
import script from "./CustomDone.vue?vue&type=script&lang=js"
export * from "./CustomDone.vue?vue&type=script&lang=js"

import "./CustomDone.vue?vue&type=style&index=0&id=c165a2a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c165a2a2"

export default script